export enum OtpForAccountMatchingType {
  email = 'EMAIL',
  sms = 'SMS',
}
